// AuthLayout.jsx - Base layout wrapper for all authentication screens
// Matches Figma design - simple solid background.
//
// `variant` defaults to the dark surface every auth screen has always used.
// The auth screens opt into "light", which paints the design's green-to-blue
// diagonal (.bg-login -> --login-bg-image).
//
// `align` defaults to "top": the design starts the column 40px below the top
// of the page rather than centring it, so a short screen (login) leaves its
// slack at the bottom. Centring also clipped the top of the long signup form
// once it grew past the viewport. "center" is for screens with no logo to
// anchor — the AuthCallback spinner.
import React from 'react';

const AuthLayout = ({ children, variant = 'dark', align = 'top' }) => {
  const surface = variant === 'light' ? 'bg-login' : 'bg-[#191919]';
  const placement = align === 'center' ? 'items-center' : 'items-start py-[40px]';

  return (
    <div
      className={`min-h-screen flex justify-center relative overflow-hidden ${surface} ${placement}`}
    >
      {/* Main content area */}
      <div className="w-full max-w-md px-4">{children}</div>
    </div>
  );
};

export default AuthLayout;
